var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuotation1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.582H7.85156V18.8725C7.85156 20.181 6.78703 21.2455 5.47852 21.2455H2.46094V27.1049H5.47852C10.0179 27.1049 13.7109 23.4119 13.7109 18.8725V2.87109H0V16.582Z",
    fill: "#3685FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2891 2.87109V16.582H24.1406V18.8725C24.1406 20.181 23.0761 21.2455 21.7676 21.2455H18.75V27.1049H21.7676C26.307 27.1049 30 23.4119 30 18.8725V2.87109L16.2891 2.87109Z",
    fill: "#3685FB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation1);
export default __webpack_public_path__ + "static/media/quotation 1.2c6d12da034327b38ca7dd35d13187dc.svg";
export { ForwardRef as ReactComponent };